import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Grid, IconButton } from "@mui/material";
import ScreenDropdown from "app/components/common/ScreenDropdown";
import CountryChart from "app/components/charts/CountryChart";
import Screen7Logo from "app/components/Screen7Logo";
import Treemap from "./Screen7Graphs/Treemap";
import "./Screen7.css";
import { green, red } from "@mui/material/colors";
import advancementIcon from "app/assets/s7_icons/Advancement.png";
import lateralAdvancementIcon from "app/assets/s7_icons/LateralAdvancement.png";
import similar from "app/assets/s7_icons/Similar.png";
import lateralTransition from "app/assets/s7_icons/LateralTransition.png";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import DoubleBarChart from "./Screen7Graphs/DoubleBarChart";
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

import {
  fetchLeftMenuDataScreen7,
  fetchTreeMapDataScreen7,
  fetchBarChartDataScreen7,
  fetchFeederDataScreen7,
} from "../../7screen/redux/screen7/actions";
import { changeScreenOrientation, updateDataSources } from "../../7screen/redux/ScreensCommon/actions";
import { logActivity } from "../redux/api/loggingAPI";
import { UserActivityConstants } from "api/UserActivityConstants";

const Screen7NavTitles = ["Pipeline", "Advancement"];

const Screen7menuBarTitles = [
  {
    title: "Openings",
    metric: "openings",
  },
  {
    title: "Income Increase",
    metric: "median_income_diff",
    metric_percent: "median_income_percent_diff",
  },
  {
    title: "Automation Risk",
    metric: "risk_category",
  },
  {
    title: "Turnover",
    metric: "turnover",
    metric_trend: "turnover_diff",
  },
];

const iconMap = {
  LateralAdvancement: lateralAdvancementIcon,
  LateralTransition: lateralTransition,
  Similar: similar,
  Advancement: advancementIcon,
};

const Screen7 = (props) => {
  const [topology, setTopology] = useState(null);
  const [countryData, setCountryData] = useState(null);
  const [subMenuIndex, setSubMenuIndex] = useState(0);
  const [leftMenuIndex, setLeftMenuIndex] = useState(0);
  const [leftMenuData, setLeftMenuData] = useState([]);
  const [treeMapData, setTreeMapData] = useState([]);
  const [pipelineData, setPipelineData] = useState({});
  const [feederData, setFeederData] = useState([]);

  const pipelineMenuTitles = [
    { title: "Less than high school diploma" },
    { title: "High school diploma or equivalent" },
    { title: "Some college, no degree" },
    { title: "Associate's degree" },
    { title: "Bachelor's degree" },
    { title: "Master's degree" },
    { title: "Doctoral or professional degree" },
  ];

  useEffect(() => {
    setLeftMenuData(props.leftMenuData);
  }, [props.leftMenuData]);

  useEffect(() => {
    if (leftMenuData.length === 0) setTreeMapData([]);
    else setTreeMapData(props.treeMapData);
  }, [props.treeMapData, leftMenuData]);

  useEffect(() => {
    setPipelineData(props.pipelineData);
  }, [props.pipelineData]);

  useEffect(() => {
    setFeederData(props.feederData);
  }, [props.feederData]);

  const refreshData = () => {
    const { county, occupation } = props;
    if (!county || !occupation) return;
    props.fetchLeftMenuDataScreen7(county, occupation);
    setLeftMenuIndex(0);
    props.fetchBarChartDataScreen7(county, occupation);
    props.fetchFeederDataScreen7(county, occupation);
    // props.fetchTreeMapDataScreen7(county, occupation);
  };

  useEffect(() => {
    if (leftMenuData.length > 0) {
      props.fetchTreeMapDataScreen7(
        leftMenuData[0].soc_ref,
        leftMenuData[0].soc_target
      );
    }
  }, [leftMenuData]);

  useEffect(() => {
    fetch("https://code.highcharts.com/mapdata/countries/us/us-all.topo.json")
      .then((response) => response.json())
      .then((json) => {
        setTopology(json);
      });
    fetch(
      "https://cdn.jsdelivr.net/gh/highcharts/highcharts@v7.0.0/samples/data/us-population-density.json"
    )
      .then((response) => response.json())
      .then((json) => {
        json.forEach((item) => {
          item.code = item.code.toUpperCase();
        });
        setCountryData(json);
      });
    refreshData();
  }, []);

  useEffect(() => {
    refreshData();
  }, [props.county, props.occupation]);

  const changeSubMenu = (i) => {
    setSubMenuIndex(i);

    logActivity({
      screen : UserActivityConstants.SCREEN7.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action_target : Screen7NavTitles[i],
      action : UserActivityConstants.SCREEN7.ACTIONS.CHANGE_SUB_MENU
    })
  };

  const parsePipeLineTopBarData = (data) => {
    return (data === null || data == 0) ? "-" : "$" + parseInt(data).toLocaleString();
  };

  const handleDataSourceToggle = () => {
    props.updateDataSources()
    logActivity({
      screen : UserActivityConstants.SCREEN7.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action_target : UserActivityConstants.COMMON_ACTIONS.TOGGLE_DATA_SOURCE,
      action : UserActivityConstants.COMMON_ACTIONS.TOGGLE_DATA_SOURCE
    })
  }

  const handleMenuBarData = (metric, metricData) => {
    if (metric.title === "Income Increase") {
      return (
        (metricData[metric.metric] > 0 ? "+" : "-") +
        " $" +
        metricData[metric.metric].toLocaleString().replace(/-/, "") +
        ` (${(metricData[metric.metric_percent] * 100).toFixed(0)}%)`
      );
    } else if (metric.title === "Turnover") {
      return (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item sx={12}>
            {(metricData[metric.metric] * 100).toFixed(0) + "%"}
          </Grid>
          {metricData[metric.metric_trend] > 0 ? (
            <ArrowUpwardIcon />
          ) : (
            <ArrowDownwardIcon />
          )}
        </Grid>
      );
    } else if (metric.title === "Openings") {
      return metricData[metric.metric].toFixed(0);
    } else {
      return metricData[metric.metric];
    }
  };
  const handleLeftMenuClick = (menuItem, i) => {
    setLeftMenuIndex(i);
    props.fetchTreeMapDataScreen7(menuItem.soc_ref, menuItem.soc_target);
  };
  return (
    <div className="screen-wrapper">
      <header className="screen-header">
        <IconButton
              id="data-sources-icon"
              style={{
                color: "white",
                marginLeft: 20,
                marginRight: -60,
                marginTop: -155,
                position: 'relative', // This is required for z-index to work
                zIndex: 1000,
              }}
              onClick={handleDataSourceToggle}
            >
              <LibraryBooksIcon className="swap-icon" />
            </IconButton>
        <div className="title">Pathways</div>
        <div className="screen-menu">
          {Screen7NavTitles.map((title, i) => (
            <div
              key={i}
              className={`screen-menu-item ${
                subMenuIndex === i ? "selected" : ""
              }`}
              onClick={() => changeSubMenu(i)}
            >
              {title}
              <br />
            </div>
          ))}
        </div>
      </header>
      <Grid
        container
        className="screen-content-wrapper screen-content-wrapper-7"
      >
        <Grid container className="screen-content-grid-7">
          {subMenuIndex === 0 && (
            <Grid item justifyContent="center" alignItems="center" xs={8}>
              <Grid item xs={12}>
                <div
                  className="graph-title"
                  justifyContent="center"
                  alignItems="center"
                  style={{ marginBottom: "50px", textAlign: "center" }}
                >
                  Education Distribution
                </div>
              </Grid>
              <Grid
                container
                direction="row" // Set the direction to "row" for flexbox
                spacing={2}
                className="screen-7-pipeline-menu-bar"
              >
                {pipelineMenuTitles.map((metric, i) => (
                  <Grid
                    item
                    justifyContent="center"
                    alignItems="center"
                    xs={true} // Set xs to true for flexbox to take up equal fraction
                    key={i}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="screen-7-pipeline-menu-bar-item">
                      {metric.title}
                    </div>
                    <Grid container>
                      <Grid
                        item
                        xs={true} // Set xs to true for flexbox to take up equal fraction
                        className="screen-7-pipeline-menu-bar-content"
                      >
                        {Object.keys(pipelineData).length > 0
                          ? pipelineData[metric.title]
                            ? parsePipeLineTopBarData(
                                pipelineData[metric.title].personal_income
                              )
                            : "-"
                          : "N/A"}
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
              <Grid style={{ height: 800 }}>
                {Object.keys(pipelineData).length > 0 ? (
                  <DoubleBarChart feeder_data={pipelineData} />
                ) : (
                  <div style={{ textAlign: "center", paddingTop: 400 }}>
                    {" "}
                    No data available{" "}
                  </div>
                )}
              </Grid>
            </Grid>
          )}
          {subMenuIndex === 0 && (
            <Grid
              item
              justifyContent="center"
              alignItems="center"
              xs={4}
              className="pipeline-right"
            >
              <Grid container className="pipeline-right-item">
                <Grid
                  item
                  xs={12}
                  style={{
                    backgroundColor: "#184B7C",
                    overflowY: "scroll",
                    height: "calc(63vh + 120px)",
                    marginTop: "50px",
                  }}
                  className="always-show-scrollbar"
                >
                  <div className="pipeline-right-item-title">Feeders</div>
                  <div
                    style={{
                      borderBottom: "2px solid #255582",
                      margin: "0 20px",
                    }}
                  ></div>
                  {feederData.length > 0 ? (
                    feederData.map((item, i) => (
                      <div key={i}>
                        <div
                          className="pipeline-right-item-content"
                          style={{ paddingTop: 20, paddingBottom: 20}}
                        >
                          <div className="pipeline-right-item-content-title">
                            {item.occupation}
                          </div>
                          <div className="pipeline-right-item-content-subtitle" style={{ fontStyle: 'italic' }}>
                            {item.major_category}
                          </div>
                        </div>
                        <div
                          style={{
                            borderBottom: "2px solid #255582",
                            margin: "0 20px",
                          }}
                        ></div>
                      </div>
                    ))
                  ) : (
                    <div style={{ textAlign: "center", paddingTop: 400 }}>
                      {" "}
                      No data available{" "}
                    </div>
                  )}
                </Grid>
              </Grid>
            </Grid>
          )}
          {subMenuIndex === 1 && (
            <Grid item justifyContent="center" alignItems="center" xs={3.5}>
              <Grid container className="screen-7-left-menu">
                {leftMenuData.length > 0 ? (
                  leftMenuData.map((menuItem, i) => (
                    <Grid
                      container
                      justifyContent="center"
                      alignItems="center"
                      className={
                        leftMenuIndex === i
                          ? "screen-7-left-menu-item-selected"
                          : "screen-7-left-menu-item"
                      }
                      onClick={() => {
                        handleLeftMenuClick(menuItem, i);
                      }}
                      key={i}
                    >
                      <Grid item xs={10}>
                        <div key={i}>{menuItem.label}</div>
                        <div className="tooltip">Advancement Type: <b>{menuItem.category}</b> <br></br>Major Occupation Group: <b>{menuItem.label}</b> <br></br>Similarity: <b>{menuItem.score}%</b></div>
                      </Grid>
                      <Grid item xs={2}>
                        <div>
                          <img
                            src={iconMap[menuItem.icon]}
                            style={{ width: "2em" }}
                          />
                        </div>
                      </Grid>
                    </Grid>
                  ))
                ) : (
                  <div
                    style={{ textAlign: "center", paddingTop: 250, width: 400 }}
                  >
                    {" "}
                    No data available{" "}
                  </div>
                )}
              </Grid>
            </Grid>
          )}
          {subMenuIndex === 1 && (
            <Grid justifyContent="center" alignItems="center" xs={8.5}>
              <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={12}>
                  <div
                    className="graph-title"
                    justifyContent="center"
                    alignItems="center"
                    style={{ marginBottom: "50px", textAlign: "center" }}
                  >
                    Viable Advancement Occupations
                  </div>
                </Grid>
                <Grid
                  container
                  direction="column"
                  className="screen-7-menu-bar"
                >
                  {Screen7menuBarTitles.map((metric, i) => (
                    <Grid justifyContent="center" alignItems="center">
                      <Grid item>
                        <div key={i} className="screen-7-menu-bar-item">
                          {metric.title}
                        </div>
                      </Grid>
                      <Grid item>
                        <div
                          key={i}
                          className="screen-7-menu-bar-item"
                          style={{ fontWeight: "bold" }}
                        >
                          {leftMenuData && leftMenuData.length > 0
                            ? handleMenuBarData(
                                metric,
                                leftMenuData[leftMenuIndex]
                              )
                            : "N/A"}
                        </div>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
                {treeMapData.length > 0 ? (
                  <Treemap data={treeMapData} />
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      marginTop: 300,
                      height: 600,
                      width: 1000,
                    }}
                  >
                    {" "}
                    No data available
                  </div>
                )}
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    county: state.Screen1Reducer.regionSelected,
    occupation: state.Screen5Reducer.occupationType,
    leftMenuData: state.Screen7Reducer.leftMenudata,
    treeMapData: state.Screen7Reducer.treeMapData,
    pipelineData: state.Screen7Reducer.pipelineData,
    feederData: state.Screen7Reducer.feederData,
    displayDataSources: state.ScreensCommonReducer.displayDataSources,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changeScreenOrientation,
      updateDataSources,
      fetchLeftMenuDataScreen7,
      fetchTreeMapDataScreen7,
      fetchBarChartDataScreen7,
      fetchFeederDataScreen7,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Screen7);
